import { AxiosError, AxiosInstance } from 'axios'
import { createInterceptorManager, InterceptorManager } from '../shared/interceptors/interceptor-manager'

export type HermesAPIError = AxiosError<{
  error: string
  message: string
  path: string
  statusCode: number
}>

export const isHermesAPIError = (error: AxiosError): error is HermesAPIError =>
  !!(
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'error' in error.response.data &&
    'message' in error.response.data &&
    'path' in error.response.data &&
    'statusCode' in error.response.data
  )

export function createHermesInterceptor(): InterceptorManager {
  const baseManager = createInterceptorManager()

  return {
    ...baseManager,
    registerInstance(instance: AxiosInstance) {
      baseManager.registerInstance(instance)

      instance.interceptors.response.use(
        (response) => response,
        (error) => {
          const defaultErrorHandler = baseManager.getDefaultErrorHandler()

          if (isHermesAPIError(error)) {
            const errorHandlers = baseManager.getErrorHandlers()
            const errorType = error.response?.data?.error
            const handler = errorType && errorHandlers[errorType]
            if (handler) {
              handler(error)
            } else if (defaultErrorHandler) {
              defaultErrorHandler(error)
            } else {
              console.error('Unhandled API error:', error.response?.data.error, error.response?.data.message)
            }
          }
          return Promise.reject(error)
        }
      )
    }
  }
}

export const hermesInterceptor = createHermesInterceptor()
